
import Vue from 'vue';
import { SecurityController } from '@/plugins/securityController';
import { ApiData } from '@/plugins/apiData';
import { EventBus } from '@/plugins/eventBus';
import { Login } from '@/plugins/logins';
import { ApiUsers } from '@/plugins/apiUsers';
import { LogIt } from '@/plugins/webApi';
import { GetUserName } from '@/plugins/storageWars';

export default Vue.extend({
  name: 'DefaultSettings',
  data: () => ({
      lkUser: '',
      users: Array<Login>(),
      userHeader: [
        {
          text: 'Login Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {
          text: 'Last Login',
          align: 'middle',
          value: 'lastLogin',
        },
        {
          text: 'Session',
          align: 'end',
          value: 'session',
          sortable: false,
        },
      ],
  }),
  methods: {
    deleteUser(item: any) {
      const ix = this.users.indexOf(item as never);
      confirm(`Are you sure about deleting ${item.name}?`) ? this.users.splice(ix, 1) && this.removeUser(item) : this.clear();
    },
    removeUser(user: Login) {
      EventBus.$emit('message', { context: 'info', text: `User ${user.name} is going to be removed` });
      new ApiUsers({ isDelete: true, name: user.name }).send()
        .then((resp) => {
          if (resp.data) {
            if (resp.data.rows) {
              EventBus.$emit('message', { context: 'info', text: `User ${user.name} has been removed` });
            } else {
              EventBus.$emit('message', { context: 'error', text: `User ${user.name} FAILED to be removed` });
            }
          }
        })
        .catch((e) => {
          EventBus.$emit('message', { context: 'error', text: `User ${user.name} removal caused an error: ${e}` });
          LogIt(`(Settings/Default.vue)->removeUser() ${e}`, true);
        })
        .finally(() => {
          this.clear();
        });
    },
    clear() {
      this.users = Array<Login>();
      this.lkUser = '';
      this.getLogins();
    },
    save() {
      if (this.lkUser.trim().length > 2) {
        const lk = new SecurityController(this.lkUser.toLowerCase().trim(), null);
        const api = new ApiData({ table: 'logins', insert: true, query: { name: lk.hash() } });
        api.send()
          .then((res) => {
            const r = res.data;
            if (r.error) {
              EventBus.$emit('message', { context: 'error', text: r.error });
            } else {
              if (r.rows) {
                EventBus.$emit('message', { context: 'success', text: 'User has been Added' });
              }
            }
            this.clear();
          })
          .catch((err) => {
            EventBus.$emit('message', { context: 'error', text: err });
            LogIt(`(Settings/Default.vue)->save() ${err}`, true);
          });
      } else {
        EventBus.$emit('message', { context: 'error', text: 'LaunchKey username needs to be actual text' });
      }
    },
    changeDate(list: Login[]): Login[] {
      const d = new Date(0);
      list.forEach((u) => {
          if (u.lastLogin) {
            d.setUTCSeconds(parseInt(u.lastLogin, 10));
            u.lastLogin = d.toISOString();
          }
      });
      return list;
    },
    getLogins() {
      const api = new ApiData({ table: 'logins' });
      api.send()
        .then((res) => {
          const r = res.data;
          if (r.error) {
            EventBus.$emit('message', { context: 'error', text: r.error });
          } else {
            if (r) {
              this.users = this.changeDate(r);
              EventBus.$emit('message', { context: 'success', text: 'Users Loaded' });
            }
          }
        })
        .catch((err) => {
          EventBus.$emit('message', { context: 'error', text: err });
          LogIt(`(Settings/Default.vue)->getLogins() ${err}`, true);
        });
    },
  },
  mounted() {
    LogIt(`Entered ADMIN console`, false);
    this.getLogins();
  },
});
